<section id="fs1">
  <app-spinner *ngIf="loading; else display"></app-spinner>
  <ng-template #display>
    <div [ngClass]="{ 'content': variant === 'experimental', 'content-experimental': variant === 'experimental' }">
      <div class="heading" *ngIf="sites">
        Booking a promotion is easy, simply pick which website you want to be featured on
      </div>
      <hr>
    </div>
    <div *ngIf="variant === 'experimental'" class="site-cards">
      <div class="sites-container" *ngFor="let site of sites">
        <app-site-card *ngIf="site && !site.hiddenFromFeatures" [site]="site"></app-site-card>
      </div>
    </div>
    <div *ngIf="variant === 'control'">
      <div *ngFor="let site of sites">
        <app-site-advert-author *ngIf="site && !site.hiddenFromFeatures" [site]="site"></app-site-advert-author>
        <div *ngIf="displayPromoStacksModalForFeatures && site.name === 'Red Feather Romance'">
          <app-promo-stacks-banner [user]="user"></app-promo-stacks-banner>
          <hr>
        </div>
      </div>
    </div>
  </ng-template>
</section>
